export default __webpack_public_path__ + "static/media/21.2e70cb3d.jpg";